import { useParams } from "react-router-dom";
import ExtendService from "./ExtendService";
import { Box } from "@mui/material";

export const ShowService = () => {
  const { id } = useParams();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendService row={{ id, onUpdate: () => {}, onDelete: () => {} }} />;
    </Box>
  );
};
